import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
})

// this will be used to spin up modals in the future via events
export class BryntumGridConfigurationBuilderService {
    static serviceName: string = 'bryntumGridConfigurationBuilderService';

    getClearFilterActionHeaderButton() {
      return () => `<label>Action</label><br><button class="clearfilter btn-sm btn btn-primary">Clear Filters</button>`
  }
}
